import { writable } from 'svelte/store';
import type { possibleLocaleEnums } from '../translations/translations';
import { LocaleEnum } from '@wizbii/utils/models';

export const locale = writable<possibleLocaleEnums>(LocaleEnum.fr_FR);
